import { useConfig } from '../../defaultConfig';
import { Account } from '../../generated-types';

export const useAccountSupportsCards = (account: Account | undefined): boolean => {
    const { validCardKos } = useConfig();
    const validAccountKos = validCardKos?.split(',');
    if (!account) return false;
    return account.koCode === null || validAccountKos.find((code) => account.koCode?.startsWith(code)) !== undefined;
};
